import { Box, Container, Link, Typography, styled } from '@mui/material';

const FooterWrapper = styled(Container)(
  ({ theme }) => `
        margin-top: ${theme.spacing(4)};
`
);

function Footer() {
  return (
    <FooterWrapper className="footer-wrapper">
      <Box
        pb={4}
        display={{ xs: 'block', md: 'flex' }}
        alignItems="center"
        textAlign={{ xs: 'center', md: 'left' }}
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="subtitle1">
            &copy; {new Date().getFullYear()} - <Link
            href="https://krinnerconnect.com/en"
            target="_blank"
            rel="noopener noreferrer"
          >Krinner Connect</Link>
          </Typography>
        </Box>
      </Box>
    </FooterWrapper>
  );
}

export default Footer;
